import { apiClient } from '../../utils/api'
import { ApiResponse } from '../../types/api'

export interface SalesInitDataParams {
  def_branch: number | string
  begin_screen?: boolean
}

export interface SalesInitDataResponse {
  status: string
  begin_screen: boolean
  staff: any[]
  staff_selected: number
  branches: any[]
  product_name: any[]
  product_code: Record<string, any>
  currencies: any[]
  currencies_key_id: Record<string, any>
  branches_key_id: Record<string, any>
  pay_method: any
  account_guide: any[]
  account_guide_key_id: Record<string, any>
  cost_centers: any[]
  cost_centers_key_id: Record<string, any>
  setting: any
  sales_setting: any
  units: any[]
  units_key_id: Record<string, any>
  invoiceScreenAssumptions: any
}

export interface CreateSalesInvoiceRequest {
  def_branch: number | string
  staff_user_id: number | string
  payment_type: 1 | 2
  payment_method: string | number
  client_name?: string
  parent_account_guide_id?: number | string
  customer_phone?: string
  sales_state?: string
  delivery_address_id?: number | string
  delivery_address?: string
  invoice_address_id?: number | string
  invoice_address?: string
  client_type?: string
  identity_type?: string
  tax_or_identity_number?: string
  print_without_header?: '0' | '1'
  print_grouped_items?: '0' | '1'
  print_with_background?: '0' | '1'
  val: Array<{
    visible_product_code?: string
    product_code: string | number
    karat?: string | number
    quantity_num?: string | number
    insertion_num?: string
    carat?: string | number
    unit?: string | number
    quantity: string | number
    stone_weight?: string | number
    cost_center_id_1?: string | number
    selling_price?: string | number
    salary?: string | number
    total_salaries?: string | number
    discount?: string | number
    discount_value?: string | number
    vat?: string | number
    total?: string | number
    bond_num?: string
    selling_time?: string
    bond_date: string
    payment_type?: string | number
    parent_account_guide_id?: string | number
    account_guide_id?: string | number
    sales_state?: string
    payment_method_sales?: string | number
    payment_method?: string | number
    def_branch?: string | number
    // optional multiple payments fields supported by backend validation
    payment_1_amount?: string | number
    payment_1_payment_method?: string | number
    payment_1_reference?: string
    payment_1_currency_id?: string | number
    payment_1_account_guide_id?: string | number
    payment_2_amount?: string | number
    payment_2_payment_method?: string | number
    payment_2_reference?: string
    payment_2_currency_id?: string | number
    payment_2_account_guide_id?: string | number
    payment_3_amount?: string | number
    payment_3_payment_method?: string | number
    payment_3_reference?: string
    payment_3_currency_id?: string | number
    payment_3_account_guide_id?: string | number
    payment_4_amount?: string | number
    payment_4_payment_method?: string | number
    payment_4_reference?: string
    payment_4_currency_id?: string | number
    payment_4_account_guide_id?: string | number
    payment_5_amount?: string | number
    payment_5_payment_method?: string | number
    payment_5_reference?: string
    payment_5_currency_id?: string | number
    payment_5_account_guide_id?: string | number
  }>
}

export interface CreateSalesInvoiceResponse {
  status: string
  type: 'store' | 'update'
  bond_num: string
  kayed_num: string
  sales_state: string
  uuid: string
  printUrl?: string | null
  sales?: any
}

export class SalesService {
  private readonly basePath = '/v1/default'

  async getInitialData(params: SalesInitDataParams): Promise<ApiResponse<SalesInitDataResponse>> {
    return apiClient.get(`${this.basePath}/sales-init-data`, params)
  }

  async create(data: CreateSalesInvoiceRequest): Promise<ApiResponse<CreateSalesInvoiceResponse>> {
    return apiClient.post(`${this.basePath}/sales`, data)
  }

  async update(bondNum: string, data: CreateSalesInvoiceRequest): Promise<ApiResponse<CreateSalesInvoiceResponse>> {
    return apiClient.put(`${this.basePath}/sales/${bondNum}`, data)
  }

  async list(params: Record<string, any>): Promise<ApiResponse<any>> {
    return apiClient.get(`${this.basePath}/sales`, params)
  }

  async show(bondNum: string): Promise<ApiResponse<any>> {
    return apiClient.get(`${this.basePath}/sales/${bondNum}`)
  }


  async destroy(bondNum: string): Promise<ApiResponse<{ status: string; bond_num: string }>> {
    return apiClient.delete(`${this.basePath}/sales/${bondNum}/delete`)
  }
}

export const salesService = new SalesService()
